<template lang="pug">
div
  div(v-if="has_permission")
    modal-change-orders(:form='newRecord', :is-add='isModalAdd')
    modal-change-orders-approve(:form='newRecord', :is-add='isModalAdd')
    vm-row.heading(vm-w="12")
      vm-row(vm-w="12")
        vm-col(vm-type="flex" vm-justify="flex-end" vm-lg=12 vm-sm=12)
          div
            vm-button.separador-btn(icon="plus" @click="addChangeOrder" v-if="change_orders_store_permission && inOrder.status != 5") {{ $t('strings.add') }}
        vm-col.card(vm-sm=12)
          vm-table(:data="changeOrders")
            template(slot="header")
              .d-flex.justify-content-between
                div
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('change_orders.' + column) }}
              vm-th
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column != 'status' && column != 'amount' && column != 'created_by' && column != 'type'") {{data[indextr][column]}}
                  slot(v-if="column == 'created_by'") {{ data[indextr]['user']['name'] }}
                  slot(v-if="column == 'amount'") {{ data[indextr]['amount'] | currency }}
                  vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{data[indextr]['status_display']}}
                  vm-status-indicator(v-if="column == 'type'" :pulse="data[indextr]['type'] !== 'Activo'" :color="colorType(data[indextr]['type'])") {{data[indextr]['type_display']}}
                vm-td
                  vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                    vm-dropdown-menu
                      vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] === 1" @click="setApproveChangeOrder(data[indextr])")
                        vm-icon(icon="checkmark-outline")
                        slot &nbsp;{{ $t('change_orders.approve') }}
                      vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] != 3 " @click="setActionChangeOrder(data[indextr], 'cancel')")
                        vm-icon(icon="close-outline")
                        slot &nbsp;{{ $t('change_orders.cancel') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="deleteChangeOrderConfirm(data[indextr])")
                        vm-icon(icon="trash-2-outline")
                        slot &nbsp;{{ $t('strings.delete') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="openViewer(data[indextr].file_created, data[indextr].file_created_url)" v-if="data[indextr].file_created && change_orders_update_permission")
                        vm-icon(icon="eye-outline")
                        slot &nbsp;{{ $t('change_orders.see_created_attachment') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="openViewer(data[indextr].file_approved, data[indextr].file_approved_url)" v-if="data[indextr].file_approved && change_orders_update_permission")
                        vm-icon(icon="eye-outline")
                        slot &nbsp;{{ $t('change_orders.see_approved_attachment') }}
  #no-access(v-else)
    access-denied
</template>
<script>
import ModalChangeOrders from '@/components/in-order/ModalChangeOrders.vue'
import ModalChangeOrdersApprove from '@/components/in-order/ModalChangeOrdersApprove.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ChangeOrders',
  components: {
    ModalChangeOrders,
    ModalChangeOrdersApprove
  },
  data: () => ({
    selected: [],
    newRecord: {},
    has_permission: true,
    change_orders_store_permission: true,
    change_orders_update_permission: true,
    isModalAdd: true,
    columns: [
      'name',
      'status',
      'type',
      'amount',
      'created_by',
      'date'
    ],
    status: [
      {
        text: 'Open',
        value: 1,
        color: '#ff8200'
      },
      {
        text: 'Approve',
        value: 2,
        color: 'success'
      },
      {
        text: 'Cancel',
        value: 3,
        color: 'danger'
      }
    ],
    type: [
      {
        text: 'Additive',
        value: 1,
        color: 'success'
      },
      {
        text: 'Deductive',
        value: 2,
        color: 'danger'
      }
    ]
  }),
  async created () {
    this.checkPermissionView('change_orders.index')
    this.$route.params.id && await this.getChangeOrders()
  },
  methods: {
    ...mapActions([
      'loadChangeOrders',
      'setModalChangeOrdersVisible',
      'setModalChangeOrdersApproveVisible',
      'actionChangeOrder',
      'deleteChangeOrder'
    ]),
    checkPermissionView (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.change_orders_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'change_orders.store') > -1
      this.change_orders_update_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'change_orders.update') > -1
    },
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code))['color']
    },
    colorType (code) {
      return this.type.find(e => e.value === parseInt(code))['color']
    },
    async getChangeOrders () {
      this.loadChangeOrders(this.$route.params)
    },
    addChangeOrder (changeOrder, index) {
      this.isModalAdd = true
      this.setModalChangeOrdersVisible(true)
    },
    async setActionChangeOrder (record, action) {
      record.id && this.actionChangeOrder({ id: record.id, action })
    },
    async setApproveChangeOrder (changeOrder, index) {
      this.isModalAdd = true
      this.newRecord = changeOrder
      this.setModalChangeOrdersApproveVisible(true)
    },
    async deleteChangeOrderConfirm (record) {
      let t = this
      this.auxDeleteChangeOrder = () => {
        t.deleteChangeOrder(record).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.record'), attribute: this.$t(record.id) }),
        accept: this.auxDeleteChangeOrder
      })
    },
    openViewer (file, url) {
      this.$viewer.show({
        urlFile: url,
        mime: 'application/pdf',
        name: file,
        color: '#FFF'
      })
    }
  },
  computed: {
    ...mapGetters([
      'inOrder',
      'changeOrders'
    ])
  }
}
</script>
<style lang="scss">
  .filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
  }
  .con-vm-tooltip {
  display: inline-block;
  position: relative;
  }
  .vm-table--header {
  padding: 10px;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
